import apiService from "./apiService";
import AppConstants from "../appConstants";

class TagService {
    getAllTag(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_TAG, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getTagDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_TAG}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerTag(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_TAG, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteTag(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_TAG}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_TAG_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new TagService();
